import { getValueFromLocalStorage } from 'flow-doctor-lib/utils/localStorage';
export const getIsHubteamSubdomain = () => window.location.href.includes('hubteam');
export const getIsInternal = () => {
  const hasInternalOverride = getValueFromLocalStorage('flow-doctor-has-internal-view');
  if (hasInternalOverride) {
    return hasInternalOverride === 'true';
  }
  return getIsHubteamSubdomain();
};